import * as angular from "angular";
import {IController} from "angular";

export class FulfillmentStepPodImagesViewerComponent implements IController {



  stepAttachments: { id: string, attachments: { id: string, name: string, url: string, purpose: string }[] };

  height: any;

  public currentViewedAttachment: { id: string, name: string, url: string, purpose: string };
  public currentViewedAttachmentIndex: number;
  public totalImages: number;
  public canUpload: boolean;
  public pattern = "'.pdf,.tif,.tiff,.bmp,.jpeg,.jpg,.gif,.png,.eps,.raw,.cr2,.nef,.orf,.sr2'"

  constructor() {

  }

  $onInit() {

    this.currentViewedAttachment = this.stepAttachments.attachments[0];
    if (this.stepAttachments?.attachments?.length) {
      this.currentViewedAttachmentIndex = 0;
    }
    this.totalImages = this.stepAttachments?.attachments.length;

  }

  $onChanges(changes: angular.IOnChangesObject) {
    if (changes.stepAttachments && !changes.stepAttachments.isFirstChange()) {
      this.$onInit();
    }
  }

  nextImage() {
    const nextIndex = (this.currentViewedAttachmentIndex + 1) === this.stepAttachments?.attachments.length ? 0 : this.currentViewedAttachmentIndex + 1;
    this.currentViewedAttachment = this.stepAttachments?.attachments[nextIndex];
    this.currentViewedAttachmentIndex = nextIndex;
  }

  previousImage() {
    const nextIndex = this.currentViewedAttachmentIndex ? this.currentViewedAttachmentIndex - 1 : this.stepAttachments?.attachments.length - 1;
    this.currentViewedAttachment = this.stepAttachments?.attachments[nextIndex];
    this.currentViewedAttachmentIndex = nextIndex;
  }

}

angular
  .module('bringoz.admin.commons')
  .component('fulfillmentStepPodImagesViewer', {
    bindings: {
      stepAttachments: '<',
      height: '<?',
    },
    template: require('./fulfillment-step-pod-images-viewer.html').default,
    controller: FulfillmentStepPodImagesViewerComponent
  });
